import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const InfoTooltip = ({ title, placement = 'top', iconSx = {}, ...props }) => (
  <Tooltip
    title={<span style={{ fontSize: 13, color: '#fff' }}>{title}</span>}
    placement={placement}
    arrow
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: '#222',
          color: '#fff',
          fontSize: 13,
          borderRadius: 1,
          px: 1.5,
          py: 0.7,
          boxShadow: 'none',
        }
      },
      arrow: {
        sx: {
          color: '#222',
        }
      }
    }}
    {...props}
  >
    <InfoOutlinedIcon sx={{ color: '#888', fontSize: 16, verticalAlign: 'middle', opacity: 1, ...iconSx }} />
  </Tooltip>
);

export default InfoTooltip; 